import { Icon } from "@blocks/components";
import { cn } from "@blocks/utils";
import { InnerBlocks } from "@wordpress/block-editor";
import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import dynamicClassNames from "../../utils/dynamic-classnames";

const Save: React.ComponentType<BlockSaveProps<any>> = (props) => {
	const {
		attributes: {
			clientId,
			container,
			cssID,
			className,
			overlay,
			height,
			align,
			topSeparator,
			bottomSeparator,
			orientation,
			justification,
			alignment,
		},
	} = props;

	const responsiveClassNames = dynamicClassNames({
		orientation,
		justification,
		alignment,
	});

	return (
		<div
			id={cssID ?? undefined}
			className={cn(
				`mzb-section mzb-section-${clientId}`,
				className,
				align && `align${align}`
			)}
		>
			{overlay && <div className="mzb-overlay" />}
			{topSeparator &&
				topSeparator.topSeparatorIcon &&
				topSeparator.topSeparatorIcon !== "none" && (
					<span className="mzb-top-separator">
						<Icon
							type="frontendIcon"
							name={topSeparator.topSeparatorIcon}
						/>
					</span>
				)}
			<div
				className={cn(
					{ "mzb-container": container === "contained" },
					{ "mzb-container-fluid": container === "stretched" }
				)}
			>
				<div
					className={cn(
						`mzb-section-inner${
							"fit-to-screen" === height
								? " mzb-height-fit-to-screen"
								: ""
						}`,
						...Object.values(responsiveClassNames)
					)}
				>
					<InnerBlocks.Content />
				</div>
				{bottomSeparator &&
					bottomSeparator.bottomSeparatorIcon &&
					bottomSeparator.bottomSeparatorIcon !== "none" && (
						<span className="mzb-bottom-separator">
							<Icon
								type="frontendIcon"
								name={bottomSeparator.bottomSeparatorIcon}
							/>
						</span>
					)}
			</div>
		</div>
	);
};

export default Save;
